<template>
    <div>
        <!-- Dropdown for smaller screens -->
        <b-dropdown v-if="forceSmallVariant || isSmallScreen" id="tabCategoryDropdown" :text="selectedCategory ? selectedCategory.name : $t('common.all')" variant="outline" class="d-block" style="min-width: 50px;">
            <template #button-content>
                <i :class="['bi', { 'bi-funnel': !selectedCategory, 'bi-funnel-fill': selectedCategory, 'text-primary': selectedCategory }]"></i>
                {{ selectedCategory ? selectedCategory.name : $t('common.all') }}
            </template>
            <b-dropdown-item @click="selectCategory(null)" :active="!selectedCategory">
                {{ $t('common.all') }}
            </b-dropdown-item>
            <b-dropdown-item v-for="item in categories" :key="item.id" @click="selectCategory(item)" :active="selectedCategory && selectedCategory.id === item.id">
                {{ item.name }}
            </b-dropdown-item>
        </b-dropdown>

        <!-- Button group for larger screens -->
        <div v-else class="btn-group flex-wrap" id="tabCategoryBar">
            <button :class="['btn', { 'category-bar-selected': !selectedCategoryId, 'category-bar-not-selected': selectedCategoryId }]" @click="selectCategory(null)">
                <i class="bi bi-funnel"></i> {{$t('common.all')}}
            </button>
            <button v-for="item in categories" :key="item.id" :class="['btn', { 'category-bar-selected': isSelectedCategory(item), 'category-bar-not-selected': !isSelectedCategory(item) }]" @click="selectCategory(item)">
                <i v-if="(selectedCategory && selectedCategory.id === item.id)" class="bi bi-funnel-fill text-primary"></i>
                {{ item.name }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        categories: Array,
        selectedCategoryId: [String, Number],
        isAdmin: Boolean,
        forceSmallVariant: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedCategory: null,
            isSmallScreen: window.innerWidth < 992 // Define breakpoint for small screens
        };
    },
    methods: {
        isSelectedCategory(category) {
            return this.selectedCategoryId && category && this.selectedCategoryId === category.id;
        },
        selectCategory(category) {
            this.selectedCategory = category;
            this.$emit('category-selected', category);
        },
        updateScreenSize() {
            this.isSmallScreen = window.innerWidth < 992;
        }
    },
    mounted() {
        window.addEventListener('resize', this.updateScreenSize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateScreenSize);
    }
};
</script>
